import { Component, Input } from '@angular/core'

@Component({
  selector: 'basin-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
})
export class StatusComponent {
  @Input() color: string
  @Input() icon: string
  @Input() label: string
  iconClass: string
  labelClass: string

  ngOnChanges(): void {
    this.setClass()
  }

  setClass(): void {
    this.iconClass = `${this.icon} basin-mr-1 basin-font-size-18`

    this.labelClass = `${this.label} basin-font-weight-500 basin-font-size-14 basin-white-space-nowrap`
  }
}
